import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

import * as utils from '../../../utils/utilities';
import * as models from '../../../utils/models';

class RTWRadiographyForm extends Form {
	state = {
		data: initialData,
		errors: {},
		loading: false,
		progress: 0,
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	schema = {
		shotNumber: Joi.string().min(3).required().label('Shot / Image Number'),
		source: Joi.string().required().label('Source'),
		sourceActivity: Joi.string().required().label('Source Activity'),
		sourceSize: Joi.string().required().label('Source Size'),
		screens: Joi.string().required().label('Screens'),
		rtTechnique: Joi.string().required().label('RT Technique'),
		odd: Joi.string().required().label('ODD'),
		sdd: Joi.string().required().label('SDD'),
		detectorType: Joi.string().required().label('Detector Type'),
		iqi: Joi.string().required().label('IQI'),
		exposureTime: Joi.string().required().label('Exposure Time'),
		spatialFrequency: Joi.string().required().label('Spatial Frequency'),
		thickness: Joi.number().required().label('Thickness (mm)'),
		essentialIQI: Joi.string().required().label('Essential IQI'),
		ug: Joi.number().required().label('UG'),
		weldingProcess: Joi.string().required().label('Welding Process'),
		resultScan: Joi.array().min(1).required().label('Scan Result Image'),
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data);

		this.setState({ data: initialData });
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'shotNumber',
							label: 'Shot / Image Number',
							placeholder: 'Enter Shot / Image Number',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'source',
							label: 'Source',
							placeholder: 'Enter Source',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'sourceActivity',
							label: 'Source Activity',
							placeholder: 'Enter Source Activity',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'sourceSize',
							label: 'Source Size',
							placeholder: 'Enter Source Size',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'screens',
							label: 'Screens',
							placeholder: 'Screens',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'rtTechnique',
							label: 'RT Technique',
							placeholder: 'Enter RT Technique',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'odd',
							label: 'ODD',
							placeholder: 'Enter ODD',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'sdd',
							label: 'SDD',
							placeholder: 'Enter SDD',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'detectorType',
							label: 'Detector Type',
							placeholder: 'Enter Detector Type',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'iqi',
							label: 'IQI',
							placeholder: 'Enter IQI',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'exposureTime',
							label: 'Exposure Time',
							placeholder: 'Enter Exposure Time',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'spatialFrequency',
							label: 'Spatial Frequency',
							placeholder: 'Enter Spatial Frequency',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'number',
							name: 'thickness',
							label: 'Thickness (mm)',
							placeholder: 'Enter Thickness (mm)',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'essentialIQI',
							label: 'Essential IQI',
							placeholder: 'Enter Essential IQI',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'ug',
							label: 'UG',
							placeholder: 'Enter UG',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'weldingProcess',
							label: 'Welding Process',
							placeholder: 'Enter Welding Process',
						})}
					</div>

					<div className="col">
						{this.renderFileInput({
							max: 1,
							multiple: false,
							name: 'resultScan',
							accept: 'image/*,application/pdf',
							label: 'Scan Result',
							sublabel: 'Upload Scan Image',
							types: utils.getFileUploadTypes(),
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Proceed')}
				</div>
			</form>
		);
	}
}

export default RTWRadiographyForm;

const initialData: models.RTWRadiographyData = {
	shotNumber: '',
	source: '',
	sourceActivity: '',
	sourceSize: '',
	screens: '',
	rtTechnique: '',
	odd: '',
	sdd: '',
	detectorType: '',
	iqi: '',
	exposureTime: '',
	spatialFrequency: '',
	thickness: 0,
	essentialIQI: '',
	ug: 0,
	weldingProcess: '',
	resultScan: [],
};
